import NoImage from './NoImage';

function getCleanHtml(html) {
  if (!html) return '';
  const replaced = html
    .replaceAll('http://', 'https://')
    .replace(/\\n/g, '')
    .replace(/\\t/g, '')
    .replace(/\\r/g, '')
    .replace(/\\/g, '')
    .replace(/^"/, '')
    .replace(/"$/, '');
  
  return replaced;
}

const SummaryReview = imageInfo => {
  const { reviewContent } = imageInfo;
  if (!reviewContent) return NoImage('e');
  return getCleanHtml(reviewContent);
};

export default SummaryReview;
